export const GET_LOOKUP = '[LOOKUP APP] GET LOOKUP';
export const ADD_LOOKUP = '[LOOKUP APP] ADD LOOKUP';
export const ERROR_LOOKUP = '[LOOKUP APP] LOOKUP ERROR';
export const OPEN_LOOKUP_DIALOG = '[LOOKUP APP] OPEN LOOKUP DIALOG';
export const CLOSE_LOOKUP_DIALOG = '[LOOKUP APP] CLOSE LOOKUP DIALOG';

export function openDialog(_AID) {
    return {
        type: OPEN_LOOKUP_DIALOG,
        id: _AID,
    }
}

export function closeDialog(_AID) {
    return {
        type: CLOSE_LOOKUP_DIALOG,
        id: _AID,
    }
}

